module.exports = __webpack_public_path__ + "static/img/p2.e1a0851.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/p2.jpg
// module id = 63
// module chunks = 1